<template>
  <div class="d-flex justify-content-between align-items-center mb-1">
    <div>
      <div class="d-flex align-items-center">
        <h1 class="mt-1 mb-1 mr-1">
          {{ overviewTitle }}
        </h1>
        <b-button
          v-if="portfolioType !== 'u' && portfolioType !== 'v'"
          class="ml-1"
          variant="outline-warning"
          size="sm"
          @click="$emit('edit-portfolio')"
        >
          <feather-icon icon="Edit2Icon" />
          Edit
        </b-button>
      </div>
      <p
        v-if="portfolioType !== 'u' && portfolioType !== 'v' && isLoggedIn && usersFullName"
        class="text-muted mb-1"
      >
        Generated for {{ usersFullName }}<template v-if="companyName">
          of {{ companyName }}
        </template> on {{ generatedDate }}
      </p>
      <p
        v-if="portfolioType === 'v'"
        class="text-muted mb-1"
      >
        Use create portfolio button to save this choice and view report pdf
      </p>
      <div
        v-if="portfolioType === 'u' && dataUpdated"
        class="font-small-3 text-muted mt-25"
      >
        Last full update on {{ formatDate(dataUpdated) }}
      </div>
    </div>

    <div
      v-if="portfolioType !== 'u'"
      class="d-flex align-items-center"
    >
      <b-button
        v-if="portfolioType !== 'u' && portfolioType !== 'v'"
        variant="outline-secondary"
        size="sm"
        class="mr-1 d-flex align-items-center"
        @click="downloadHoldingsCsv"
      >
        <b-img
          :src="require('@/assets/images/icons/file-icons/csv.png')"
          height="20"
          width="20"
        />
        <span class="ml-50 font-weight-bold text-body">Export Holdings CSV</span>
      </b-button>
      <b-button
        v-if="portfolioType === 'v'"
        variant="outline-secondary"
        size="sm"
        class="mr-1 d-flex align-items-center"
        @click="downloadVirtualHoldingsCsv"
      >
        <b-img
          :src="require('@/assets/images/icons/file-icons/csv.png')"
          height="20"
          width="20"
        />
        <span class="ml-50 font-weight-bold text-body">Export Holdings CSV</span>
      </b-button>
      <template v-if="portfolioType === 'v'">
        <span
          id="create-portfolio-wrapper"
          class="d-inline-block"
          tabindex="0"
        >
          <b-button
            variant="primary"
            :disabled="portfolioMax !== 0 && usersNumberOfPortfolios >= portfolioMax"
            @click="$emit('create-portfolio')"
          >
            <feather-icon
              v-if="!(portfolioMax !== 0 && usersNumberOfPortfolios >= portfolioMax)"
              icon="PlusIcon"
            />
            Create Portfolio
            <feather-icon
              v-if="portfolioMax !== 0 && usersNumberOfPortfolios >= portfolioMax"
              icon="LockIcon"
              class="ml-50"
            />
          </b-button>
        </span>
        <b-tooltip
          v-if="portfolioMax !== 0 && usersNumberOfPortfolios >= portfolioMax"
          target="create-portfolio-wrapper"
          triggerrs="hover"
          placement="top"
        >
          You have reached your limit of having {{ portfolioMax }} portfolios
        </b-tooltip>
      </template>
    </div>
  </div>
</template>

<script>
import {
  BButton, BTooltip, BImg,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import { formatDate } from '@core/utils/filter'

export default {
  components: {
    BButton,
    BTooltip,
    BImg,
  },
  setup() {
    return { formatDate }
  },
  props: {
    portfolioType: {
      type: [String, Number],
      default: 'u',
    },
    portfolioName: {
      type: String,
      default: '',
    },
    dataUpdated: {
      type: String,
      default: null,
    },
    searchFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      generatedDate: new Date().toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }),
    }
  },
  computed: {
    ...mapGetters('app', [
      'usersNumberOfPortfolios',
    ]),
    ...mapGetters('auth', [
      'portfolioMax',
      'isLoggedIn',
      'usersFullName',
    ]),
    companyName() {
      return this.$store.state.auth.user.companyname
    },
    overviewTitle() {
      if (this.portfolioType === 'v') {
        return 'Portfolio analysis on selected products'
      }
      if (this.portfolioType === 'u') {
        return 'Marketplace Dashboard'
      }
      return `Portfolio Report: ${this.portfolioName}`
    },
  },
  methods: {
    downloadVirtualHoldingsCsv() {
      this.$http.get('lifecycle/public/report.cfc?method=downloadCSVVirtualPortfolioHoldings', {
        params: { searchfilter: JSON.stringify(this.searchFilter) },
        responseType: 'blob',
      })
        .then(response => {
          const url = window.URL.createObjectURL(response.data)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          const [, filename] = response.headers['content-disposition'].match(/"([^']+)"/)
          a.download = filename
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },
    downloadHoldingsCsv() {
      this.$http.get('lifecycle/public/portfolio.cfc?method=downloadCSVHoldings', {
        params: { portfolioId: this.portfolioType },
        responseType: 'blob',
      })
        .then(response => {
          const url = window.URL.createObjectURL(response.data)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          const [, filename] = response.headers['content-disposition'].match(/"([^']+)"/)
          a.download = filename
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },
  },
}
</script>
